// extracted by mini-css-extract-plugin
export default {"make-call-dialog":"make-call-dialog--2jbVo","close-button":"close-button--WRsoP","phone-input":"phone-input--2naVZ"};